<template>
  <div class="page">
<div class="div">
<div class="title_header">

<headerTitle  isChange @change="studentChange"/>
</div>

<div class="vip_box">
  <div class="vip_box_btn">立即订阅</div>
</div>

<div class="gift_box">
  <div class="gift_box_title">我的礼物</div>
  <div class="gift_box_list">
    <div class="gift_box_list_left">
      <div>我的积分</div>
      <div style="font-size: 26px;color: rgb(43, 43, 43);font-family: DINPro-Bold;margin: 2px 0;">{{integral}}</div>
      <div style="color: rgb(255, 191, 52);">积分当钱花！</div>
    </div>
    <div class="gift_box_list_right">
      <div>我的物品</div>
      <div style="font-size: 26px;color: rgb(43, 43, 43);font-family: DINPro-Bold;margin: 2px 0;">00</div>
      <div>精选好物，品质保证</div>
    </div>
  </div>
</div>

<div class="menu">
  <div class="menu_row_title">常用功能</div>
<div class="menu_row">
  <div  class="menu_li" v-for="value in menuList" :key="value.id" @click="goPage(value)">
    <van-badge :content="value.content">
    <div style="margin: 4px auto;"><img :src="value.url" alt=""  height="30px" width="30px"></div>
      <div ><span class="custom-title">{{value.name}}</span></div>
    </van-badge>
    

  </div>


</div>







</div>


</div>
    <VDialog ref="VDialog" :objData="objData" />
    <!-- 内容区域 -->
    <main class="content-container">
      <router-view />
    </main>
<!-- <van-tabbar v-model="active" fixed>
  <van-tabbar-item icon="home-o">首页</van-tabbar-item>
  <van-tabbar-item icon="search" dot>运动之星</van-tabbar-item>
  <van-tabbar-item icon="friends-o" info="5">积分商城</van-tabbar-item>
  <van-tabbar-item icon="setting-o" info="20">个人中心</van-tabbar-item>
</van-tabbar> -->
  </div>
</template>

<script>
import {insertBaseSystemAccountWx,listRotationChart} from '@/api/common'
// import headerTitle from "./module/headerTitle.vue";
import VDialog from "@/components/VDialog";
import headerTitle from "@/components/homeStudentTitleCard.vue";
import { selectSportsPoints,getStudentStatus} from "@/api/parentHomePage.js";
import { getEduYearList} from "@/api/resultReporting.js";

export default {
  components: {
    headerTitle,
    VDialog
  },
  data() {
    return {
      active:'',
     countAll:undefined,
     objData: {
        checked: false,
        num: 3,
        showDialog: false,
      },
      studentTitleInfo:{},
 
menuList:[
   {
      id: 1,
      name:'学生绑定',
      url: require("@/assets/parentImg/学生绑定.png"),
    },
    {
      id: 0,
      name:'测训准考证',
      url: require("@/assets/parentImg/测训制证.png"),
    }, 
    {
      id: 2,
      name:'家庭作业',
      url: require("@/assets/parentImg/家庭作业.png"),
      content:''
    },
  
    //   {
    //   id: 4,
    //   name:'阳光跑',
    //   url: require("./image/阳光跑.png"),
    // }, 
    {
      id: 5,
      name:'健康信息申报',
      url: require("@/assets/parentImg/信息申报.png"),
    },

   
    
    //  {
    //   id: 3,
    //   name:'通讯录',
    //   url: require("./image/通讯录@2x.png"),
    // }, 
    //  {
    //    id: 6,
    //    name:'积分商城',
    //    url: require("./image/商城.png"),
    //  }, 
    //  {
    //    id: 7,
    //    name:'运动分析',
    //    url: require("./image/分析.png"),
    //  }, 
    //  {
    //    id: 8,
    //    name:'体测报告',
    //    url: require("./image/分析.png"),
    //  }, 
    //  {
    //    id: 9,
    //    name:'体锻报告',
    //    url: require("./image/分析.png"),
    //  }, 
    //  {
    //    id: 8,
    //    name:'运动之星',
    //    url: require("./image/记录.png"),
    //  }
],


    studentTitleInfo:{},
    integral:0,
    termCode:"",
    termName:"",
    }
  },
  computed: {

  },
  created() {
  },
  mounted () {
    this.init()
    
       this.studentTitleInfo = sessionStorage.getItem('studentTitleCard')?JSON.parse(sessionStorage.getItem('studentTitleCard')):{}
    if (this.studentTitleInfo.schoolCode=="LMWZ") {
      this.menuList.push(  {
      id: 6,
      name:'国家体测标准',
      url: require("@/assets/parentImg/测训制证.png"),
    },
   {
      id: 7,
      name:'作弊规则',
      url: require("@/assets/parentImg/测训制证.png"),
    },)
    }
  },
  methods: {
           // 查询学年
 async getEduYearList(){
  
 await getEduYearList({
            snCode:this.studentTitleInfo.snCode,
            schoolCode:this.studentTitleInfo.schoolCode,
          }).then(res=>{  
            res.data.data?.forEach(el=>{
                  el.text = el.name
              if(+el.isActive==1){
                  this.termCode = el.code
                  this.termName = el.name
              }
            })
          })
 },
        selectSportsPoints(){
      selectSportsPoints({
        termCode:this.termCode,
        snCode:this.studentTitleInfo.snCode,
        schoolCode:this.studentTitleInfo.schoolCode,
      }).then(res=>{
        // this.list = res.data.body||[]
        this.integral = res.data.weightScore||0
        
        
      })
    },
          getStudentStatus(){
      getStudentStatus({
        termCode:this.termCode,
        snCode:this.studentTitleInfo.snCode,
        schoolCode:this.studentTitleInfo.schoolCode,
        
      }).then(res=>{
        console.log(1111111111111111111111);
        this.menuList?.forEach(el=>{
          if (el.name=='家庭作业') {
             if (+res.data.body.homeStatus==2) {
              this.$set(el,"content",1)
              }else{
              this.$set(el,"content","")
              }
          }
        })
        
       
        
      })
    },
   async studentChange(val){
    this.studentTitleInfo =val
  await this.getEduYearList()

    this.selectSportsPoints()
    this.getStudentStatus()
  },
  onReport(){
      let data = JSON.stringify({...this.studentTitleInfo, })
      this.$router.push({path:'fitnessReport',query:{data:data}})
  },
  onbodyReport(){
      let data = JSON.stringify({...this.studentTitleInfo,})
      this.$router.push({path:'bodyForging',query:{data:data}})
  },
    init(){
       const isChecked = localStorage.getItem("isChecked") || false;
        if (!isChecked) {
          this.objData.showDialog = true;
          this.$refs.VDialog.countdown();
        }
          
    },
      goswiper(val){
    // this.$router.push({path:url})
      },
goPage(val){
let url = ''
if (val.name=='学生绑定') {
 url = '/studentBind'
}
else if (val.name=='测训准考证') {
  url = '/admissionTicket'
 }else if (val.name=='家庭作业') {
  url = '/homework'
 }else if (val.name=='健康信息申报') {
  url = '/surveyMgt'
 }else if (val.name=='阳光跑') {
  url = '/sunrunScore'
 }else if (val.name=='积分商城') {
  url = '/integralShop'
 }else if (val.name=='运动分析') {
  url = '/fitnessReportV2'
 }else if (val.name=='国家体测标准') {
  url = '/parentCenter/NationalPhysicalStandards'
 }else if (val.name=='作弊规则') {
  url = '/parentCenter/CheatingRules'
 }
 
 else if (val.name=='体测报告') {
  url = ''
  this.onReport()
  return
 }else if (val.name=='体锻报告') {
  url = ''
  this.onbodyReport()
  return
 }

 
 
if (url!=='') {
    this.$router.push({path:url})
}else  {
  this.$toast({ icon: "error", message: "暂未开放，敬请期待！！" });
}
},

  }
};
</script>
<style lang="less" scoped>
@header-footer--line-height: 40px;
@font-face {
    font-family: DINPro-Bold;
   src: url(../../assets/font/DINPro-Bold.otf);
}
@font-face {
    font-family: DINPro-Medium;
   src: url(../../assets/font/DINPro-Medium.otf);
}
.page{
  // background: #fff;
  height: 100%;
  overflow: scroll;
  padding: 4vw;
  font-size: 12px;
  // background-image: url('../../assets/background/homeBG.png');
	// background-repeat: no-repeat;
	// background-size: cover;
}

  // background-image: url('./image/顶部背景@2x.png');
	// background-repeat: no-repeat;
	// background-position: center;
	// background-size: cover;
.vip_box{
  position: relative;
  background-image: url('../../assets/parentImg/vip_bg.png');
  background-repeat: no-repeat;
	background-position: center;
	background-size: 100% 100%;
  height: 80px;
  border-radius: 15px;
  margin-bottom: 15px;
  .vip_box_btn{
    position: absolute;
    top: 22px;
    right: 15px;
    width: 80px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    border-radius: 15px;
border-color: rgb(255, 246, 237);
  border-style: solid;
  background-image: -moz-linear-gradient( 177deg, rgb(255,228,200) 1%, rgb(255,246,237) 47%, rgb(255,228,200) 100%);
  background-image: -webkit-linear-gradient( 177deg, rgb(255,228,200) 1%, rgb(255,246,237) 47%, rgb(255,228,200) 100%);
  background-image: -ms-linear-gradient( 177deg, rgb(255,228,200) 1%, rgb(255,246,237) 47%, rgb(255,228,200) 100%);

  color: rgb(110, 77, 55);



  }
}
.gift_box{
  height: 115px;
  padding: 4vw;
  border-radius: 15px;
  background-color: #fff;
  .gift_box_title{
    margin-bottom: 10px;
  }
  .gift_box_list{
    display: flex;
    justify-content: space-between;
    height: 85px;
    color: rgb(46, 139, 211);




    .gift_box_list_left{
    background-color: rgb(239, 250, 255);
    width: 42%;
    height: calc(100% - 4vw);
    border-radius: 15px;
    padding: 2.5vw;

    }
    .gift_box_list_right{
     background-color: rgb(239, 250, 255);
    width: 42%;
    height: calc(100% - 4vw);
    border-radius: 15px;
    padding: 2.5vw;

    }
  }
  




}

 .title_header{
  position:relative;
  z-index: 0;
  margin: 15px 0;
}
.title_image{
  width: 100%;
  height: 400rpx;
  position:fixed;
  z-index: -999;
}
  .fitnessBox{
    background-image: url('../../assets/image/体测报告btn.jpg');
	  background-repeat: no-repeat;
	background-size: cover;
  }
  .trainingBox{
    background-image: url('../../assets/image/锻炼报告btn.jpg');
	  background-repeat: no-repeat;
	background-size: cover;
  }
.menu{
  font-size: 12px;
  margin-top: 15px;
  background-color: #fff;
  padding: 4vw;
  border-radius: 15px;

  .menu_row_title{
      margin-bottom: 15px;
    }
  .menu_row{
    // text-align: center;
    display: flex;
    flex-wrap: wrap;
    color: rgb(46, 139, 211);
    // margin: 10px auto;
   
  
   .menu_li{
    // height: 100%;
    height: 60px;
    width: 25%;
    text-align: center;
    font-size: 10px;
    // display: flex;
    // align-items: center;
    // align-content: center;
    // justify-items: center;

    .menu_li_titleBox{
      display: flex;
      align-items: center;
      align-content: center;
    }
    &:active {
    transform: scale(0.96); // 更明显的缩放效果
    opacity: 0.95; // 调整透明度

  }
   }

 } 
}
 ::v-deep .van-grid-item__content{
    padding: 16px 6px!important;
  background: #eeeeee;
  }


.userinfo {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #aaa;
}
.myHeader{
  margin: auto;
  padding-top: 40px;
  width: 90%;
}
.swipe{

}
.my-swipe{
margin: auto;
// margin-top:15px;
width: 90%;
border-radius: 8px;
}
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    // line-height: 400rpx;
    text-align: center;
    border-radius: 8px;
  }
</style>
